<template>
  <form :class="$style.wrap" @submit.prevent="onSubmit">
    <!-- 角色 id -->
    <div :class="$style.field" style="margin-bottom: 0.2rem;">
      <input
        v-model="roleId.value"
        :placeholder="`请输入${roleId.label}`"
        :max-length="roleId.maxLength"
        :class="$style['field-input']"
      />
    </div>
    <!-- 验证码 -->
    <div
      :class="$style.field"
      style="display: flex; justify-content: space-between;"
    >
      <input
        v-model="verifyCode.value"
        :placeholder="`请输入${verifyCode.label}`"
        :max-length="verifyCode.maxLength"
        :class="$style['field-input']"
        style="width: 4.1rem"
      />
      <!-- 发送验证码按钮 -->
      <verify-code-sender
        :role-id="roleId.value"
        :pattern="roleId.pattern"
        :class="$style['btn-code']"
      />
    </div>
    <!-- 表单提交按钮 -->
    <button :class="[$style['btn-submit']]" />
    <!-- 帮助信息 -->
    <ul :class="$style.tip">
      <li v-html="roleId.tip" />
      <li v-html="verifyCode.tip" />
    </ul>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import { login } from "@/api";
import VerifyCodeSender from "./VerifyCodeSender";

export default {
  name: "BindForm",
  props: {
    loginType: Number
  },
  components: { VerifyCodeSender },
  data() {
    return {
      // 角色 id
      roleId: {
        value: "",
        label: "您的角色ID",
        maxLength: 24,
        pattern: /^[0-9]{3}[0-9]+$/,
        tip:
          "*【ID查看方式】<em>ID为一串数字</em>，打开游戏，点击  左上角头像打开角色信息面板即可查看。"
      },
      // 验证码
      verifyCode: {
        value: "",
        label: "游戏邮件验证码",
        maxLength: 6,
        pattern: /^[0-9]{6}/,
        tip:
          "*【验证码获取方式】验证码会通过<em>游戏内邮箱发放</em>，请登录游戏查看。"
      }
    };
  },
  methods: {
    ...mapActions(["setToken", "setUser", "updateAppData"]),
    validateForm() {
      const { roleId, verifyCode } = this;

      // 验证角色 id 有效性
      if (!roleId.value) {
        return `请输入${roleId.label}`;
      } else if (!roleId.pattern.test(roleId.value)) {
        return `请输入有效的${roleId.label}`;
      }

      // 验证验证码有效性
      if (!verifyCode.value) {
        return `请输入${verifyCode.label}`;
      } else if (!verifyCode.pattern.test(verifyCode.value)) {
        return `请输入有效的${verifyCode.label}`;
      }

      return false;
    },
    getUrlParam(name) {
      const url = window.location.href;
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    async onSubmit() {
      const validationError = this.validateForm();
      if (validationError) {
        this.$toast(validationError);
        return;
      }
      const { roleId, verifyCode, $bl } = this;
      const inviteCode = this.getUrlParam("code") || "";
      try {
        const { data = {}, msg } = await login({
          role_id: roleId.value,
          mail_code: verifyCode.value,
          // 邀请码
          user_sign: inviteCode
        });
        this.$toast(msg);
        if (Object.keys(data).length > 0 && data.auth_token) {
          const { auth_token, expires_in, bind_info = {} } = data;
          // 存储 token
          this.setToken({
            token: auth_token,
            expire: `${expires_in}s`
          });
          // 更新数据
          if (Object.keys(bind_info).length > 0) {
            // 设置用户基本信息
            this.setUser(bind_info);
            // 设置活动相关数据
            this.updateAppData(bind_info);
            // 绑定后回调
            this.$emit("bind-success", this.loginType);
            // 设置前端统计用户名
            if ($bl) {
              $bl.setConfig({
                setUsername: () => {
                  return String(roleId.value);
                }
              });
            }
          }
        }
      } catch (err) {
        //
      }
    },
    reset() {
      this.roleId.value = "";
      this.verifyCode.value = "";
    }
  }
};
</script>

<style lang="less" module>
@input-width: 6.5rem;
@input-height: 0.7rem;

.wrap {
  width: @input-width;
  margin: 0.3rem auto 0;
}

/* 输入项 */
.field {
  position: relative;
  height: @input-height;

  &-input {
    .size(100%);

    padding-left: 0.75em;
    border: 0.02rem solid #d3b783;
    background-color: transparent;
    font-size: 0.3rem;

    &::placeholder {
      color: inherit;
      opacity: 0.6;
    }
  }
}

.btn {
  /* 发送验证码按钮 */
  &-code {
    .size(2.27rem, @input-height);
    .background-fill("./images/btn-code.png");

    font-size: 0.37rem;
    color: #fff;
    text-shadow: 0 0.02rem 0.04rem #c38500;

    &[disabled] {
      opacity: 0.5;
      cursor: default;
    }
  }

  /* 表单提交按钮 */
  &-submit {
    .size(1.94rem, 0.68rem);
    .background-fill("./images/btn-bind.png");

    display: block;
    margin: 0.36rem auto 0;

    &[disabled] {
      opacity: 0.5;
      cursor: default;
    }
  }
}

/* 帮助信息 */
.tip {
  margin-top: 0.2rem;
  font-size: 0.2rem;
  user-select: none;
}
</style>
